import store from "assets/js/store";
import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { CASLoginService } from "../../../services/authService";
import fetchRoute from "utils/routes";
import { getUrlQueryParam } from "utils/urlUtils";
import PropTypes from "prop-types";
import { Translate } from "react-redux-i18n";
import { DialogHandler, Dialog } from "cakemail-ui-components/lib/react";
import { setLocalLocize } from "utils/languages";

function OAuthCodeLogin(props) {
	const dialogRef = useRef();

	function initDialog() {
		DialogHandler.register(dialogRef.current);
	}

	function displayErrorDialog() {
		DialogHandler.show({
			type: "error",
			title: (
				<Translate value="Login error" />
			),
			content: (
				<p>
					<Translate value={"There was an error logging you in."} />
				</p>
			),
			primaryBtnText: (
				<Translate value="OK" />
			),
			primaryBtnOnClick: () => {
				DialogHandler.hide();
				props.history.push(fetchRoute("dashboard"));
			},
		});
	}

	function redirectToDashboard() {
		window.location = `/#${fetchRoute("dashboard")}`;
	}

	function loginWithCode() {
		const code = getUrlQueryParam("code");
		const state = getUrlQueryParam("state");
		const partnerId = store.getState()?.brand?.config?.partner_account_id;

		CASLoginService(
			{ code, state, accountId: partnerId },
			redirectToDashboard, // successCallback
			displayErrorDialog // errorCallback
		);
	}

	useEffect(initDialog, []);
	useEffect(setLocalLocize, []);
	useEffect(loginWithCode, []);

	return <Dialog ref={dialogRef} />;
}

OAuthCodeLogin.propTypes = {
	history: PropTypes.object,
};

export default withRouter(
	connect(null, null)(OAuthCodeLogin)
);
